import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "../../services/axiosInstance";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { getAdBannerByDomainAction } from "../../redux/actions";
import { getImageByType, getImageUrl } from "../../utils";

const MainSectionContent = () => {
  const { domainData, adBanners } = useSelector((state) => state.Website);
  const dispatch = useDispatch();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    dispatch(getAdBannerByDomainAction());
  }, [dispatch]);

  const items = React.useMemo(() => {
    let arr = [];
    adBanners?.forEach((i) => {
      if (i.banner_dimension === "1480 * 630" && i.image_type) {
        let obj = {};
        obj.src = getImageByType(i.image_type, i.image_url ,i.image_upload);
        obj.url = i.image_url;
        obj.altText = "ad";
        obj.redirect_url = i.redirect_url;
        obj.caption = i.caption;
        arr.push(obj);
      }
    });
    return arr;
  }, [adBanners]);

  const Div = styled.div`
    // height: 434px;
    max-width: 100%;
    margin-top: 1rem;
    // .slick-slider {
    //   height: 440px;
    // }
    .slick-slide > div {
      height: 419px;
    }

    .slick-dots {
      bottom: -10px;
    }

    .slick-prev::before,
    .slick-next::before {
      color: ${domainData?.header_color ? domainData?.header_color : "orange"};
    }

    .banner-carousel--item {
      height: 100%;
      background-color: #f7f7f7;
    }

    .banner-carousel--item > div {
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
  `;

  return (
    <>
      <Div className="col-sm-12 col-md-9 ">
        <Slider {...settings}>
          {items?.length>0 &&
            items.map((ele, index) => (
              <div key={index} style={{ borderRadius:3 }} className="carousel-image-container banner-carousel--item">
                <a href={ele.redirect_url} target="_blank" rel="noreferrer">
                  <img
                    className="sliderImg" 
                    src={ele.src}
                    width="100%"
                    height="100%"
                    style={{
                      objectFit: "contain",
                    }}
                  />
                  {
                    ele?.caption?.length > 0 &&
                    <h4 style={{ borderRadius:3 }} className="carousel-caption-container" >
                      {ele?.caption}
                    </h4>
                  }
                </a>
              </div>
            ))}
        </Slider>
      </Div>
    </>
  );
};

export default MainSectionContent;
